import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PhoneIcon, MenuIcon, XIcon, ShieldCheckIcon } from 'lucide-react';
import { SITE } from '../constants/site';
const NAV = [{
  label: 'Services',
  href: '#services'
}, {
  label: 'Why Us',
  href: '#why'
}, {
  label: 'Service Area',
  href: '#area'
}, {
  label: 'Reviews',
  href: '#reviews'
}, {
  label: 'FAQ',
  href: '#faq'
}];
export function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className={`sticky top-0 z-50 w-full transition-all duration-300 ${scrolled ? 'bg-white/95 backdrop-blur shadow-md' : 'bg-white/80 backdrop-blur'}`} data-id="element-139" data-mp="36d4l6oougwqo">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 sm:px-6 lg:px-8" data-id="element-140" data-mp="3fcjdltoknhdt">
        <a href="#top" className="flex items-center gap-3" aria-label={SITE.shortName} data-id="element-141" data-mp="2wlm7hauwjyib">
          <img src={SITE.logoUrl} alt={`${SITE.shortName} logo`} className="h-12 w-auto sm:h-14" data-id="element-142" data-mp="2rkq4r0maeieh" />
        </a>

        <nav className="hidden items-center gap-8 lg:flex" aria-label="Primary" data-id="element-143" data-mp="2mng9338b1ai7">
          {NAV.map(item => <a key={item.href} href={item.href} className="text-sm font-semibold text-slate-700 transition-colors hover:text-nfblue" data-id="element-144" data-mp="2hovg9ovdtt3s">
              {item.label}
            </a>)}
        </nav>

        <div className="hidden items-center gap-3 lg:flex" data-id="element-145" data-mp="3adan3o4d1541">
          <span className="flex items-center gap-1.5 text-xs font-semibold text-nfgreen-dark" data-id="element-146" data-mp="35l9c05ixhkfl">
            <ShieldCheckIcon className="h-4 w-4" data-id="element-147" data-mp="30mfzogfdnzh0" />
            Licensed & Insured
          </span>
          <a href={SITE.phoneHref} className="inline-flex items-center gap-2 rounded-full bg-nfblue px-5 py-2.5 text-sm font-bold text-white shadow-sm transition-transform hover:scale-[1.03] hover:bg-nfblue-dark" data-id="element-148" data-mp="1wfr8slzckzg">
            <PhoneIcon className="h-4 w-4" data-id="element-149" data-mp="1rd1k8vxrsljd" />
            {SITE.phone}
          </a>
        </div>

        <button className="inline-flex h-10 w-10 items-center justify-center rounded-lg text-slate-700 lg:hidden" onClick={() => setOpen(v => !v)} aria-label={open ? 'Close menu' : 'Open menu'} aria-expanded={open} data-id="element-150" data-mp="1wd614n2lbia4">
          {open ? <XIcon className="h-6 w-6" data-id="element-151" data-mp="1mltb810cr26q" /> : <MenuIcon className="h-6 w-6" data-id="element-152" data-mp="1ml08db4ikwtv" />}
        </button>
      </div>

      <AnimatePresence data-id="element-153" data-mp="18madm256398o">
        {open && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.25
      }} className="overflow-hidden border-t border-slate-100 bg-white lg:hidden" data-id="element-154" data-mp="18p6d3uwny5z8">
            <nav className="flex flex-col px-4 py-4" aria-label="Mobile" data-id="element-155" data-mp="2t2x5de0oojt4">
              {NAV.map(item => <a key={item.href} href={item.href} onClick={() => setOpen(false)} className="rounded-lg px-3 py-3 text-base font-semibold text-slate-700 hover:bg-slate-50" data-id="element-156" data-mp="2t13vlpurxjgw">
                  {item.label}
                </a>)}
              <a href={SITE.phoneHref} className="mt-2 inline-flex items-center justify-center gap-2 rounded-full bg-nfblue px-5 py-3 text-base font-bold text-white" data-id="element-157" data-mp="hg3ffxkniaap">
                <PhoneIcon className="h-5 w-5" data-id="element-158" data-mp="w6aqvtc8qt1w" />
                {SITE.phone}
              </a>
            </nav>
          </motion.div>}
      </AnimatePresence>
    </header>;
}